import { Box, Grid, List, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { GeneralSetup } from "./../../../../../components/GeneralSetup/GeneralSetup";
import { useLocation } from "react-router-dom";
import ManageSettingsRouter from "../../../../../router/ManageSettingsRouter";
import { checkSubDomainAccess } from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import { useSelector } from "react-redux";
import styles from "../../../Manage/ManageRoot/ManageRoot.module.css";

export default function ManageSettingsRoot(props: any) {
  const location = useLocation();
  const { pathname } = useLocation();

  const { userById } = useSelector((state: any) => state.userDetails);

  const userFromLocalStorage = JSON.parse(
    localStorage.getItem("ACTIVE_INSTITUTE")!
  );

  const [isActive, setIsActive] = useState(0);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const handleStatus = React.useCallback(
    (index: number) => {
      setIsActive(index);
    },
    [setIsActive]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (
      userFromLocalStorage &&
      userFromLocalStorage.isProfileCompleted === false
    ) {
      setButtonDisabled(true);
    }
  }, [setButtonDisabled, userFromLocalStorage]);

  useEffect(() => {
    if (window.location.href.includes('Invoices')) {
			setIsActive(0);
		} else if (window.location.href.includes('Notifications')) {
			setIsActive(1);
		} else if (window.location.href.includes('Rolesandpermission')) {
			setIsActive(2);
		} else if (window.location.href.includes('Student')) {
			setIsActive(3);
		} else if (window.location.href.includes('Customize')) {
			setIsActive(4);
		} else if (window.location.href.includes('PurchaseHistory')) {
			setIsActive(5);
		}
  }, [setIsActive, location, window.location.href]);

  return (
    <Box
      sx={{ flexGrow: 1 }}
      style={{
        overflow: "auto",
        padding: "14px 16px",
        background: "#EEEEEE",
        maxHeight: "calc(100vh - 65px)",
        position: "relative",
      }}
    >
      <Box
        sx={{ flexGrow: 1 }}
        style={{
          overflow: "hidden",
          background: "#fff",
          border: "1px solid #E9E9E9",
          borderRadius: "8px",
          minHeight: "calc(100vh - 94px)",
        }}
        id="manage"
      >
        <Box>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 5 }}
          >
            <Grid
              className={styles.gridSettingsLeft}
              item
              xs={12}
              md={3}
              sm={9}
              lg={2.2}
              xl={2}
              sx={{
                maxHeight: {
                  xs: "auto",
                  sm: "auto",
                  lg: !userFromLocalStorage.isProfileCompleted
                    ? "calc(100vh - 208px)"
                    : "calc(100vh - 94px)",
                  md: !userFromLocalStorage.isProfileCompleted
                    ? "calc(100vh - 208px)"
                    : "calc(100vh - 94px)",
                },
                minHeight: {
                  xs: "auto",
                  sm: "auto",
                  lg: "calc(100vh - 94px)",
                  md: "calc(100vh - 94px)",
                },
                overflowY: "auto",
                borderRight: "1px solid #c7c7c7",
              }}
            >
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    paddingLeft: "34px",
                    fontSize: "18px",
                    marginTop: "30px",
                    marginBottom: "10px",
                    fontWeight: "500",
                    paddingRight: "45px",
                  }}
                >
                  Settings
                </Typography>
                <Box
                  sx={{
                    width: { xs: "95vw", sm: 550, lg: "auto", md: "auto" },
                    height: {
                      lg: "auto",
                    },
                    overflowY: {
                      xs: "auto",
                      lg: "hidden",
                      md: "auto",
                      sm: "auto",
                    },
                    paddingLeft: "20px",
                    paddingRight: "30px",
                  }}
                >
                  <List
                    sx={{
                      fontSize: { xs: 2 },

                      display: {
                        xs: "-webkit-box",
                        sm: "flex",
                        md: "block",
                        lg: "block",
                      },
                      alignItems: {
                        xs: "center",
                        sm: "center",
                        md: "flex-start",
                        lg: "flex-start",
                      },
                      overflowY: {
                        xs: "auto",
                        lg: "hidden",
                      },
                      padding: { xs: 0 },
                      pointerEvents: buttonDisabled ? "none" : "auto",
                      ".MuiTypography-root": {
                        fontSize: "0.8rem !important",
                      },
                    }}
                  >
                    {[
                      {
                        sectionName: "Invoices",
                        allAccess: checkSubDomainAccess(
                          "SETTINGS",
                          "INVOICES",
                          userById?.rolePermission
                        ),
                      },
                      {
                        sectionName: "Notifications",
                        allAccess: checkSubDomainAccess(
                          "SETTINGS",
                          "NOTIFICATIONS",
                          userById?.rolePermission
                        ),
                      },
                      {
                        sectionName: "Roles and Permission",
                        allAccess: checkSubDomainAccess(
                          "SETTINGS",
                          "ROLES_&_PERMISSIONS",
                          userById?.rolePermission
                        ),
                      },
                      {
                        sectionName: "Student ID",
                        allAccess: checkSubDomainAccess(
                          "SETTINGS",
                          "STUDENT_ID",
                          userById?.rolePermission
                        ),
                      },
                      {
                        sectionName: "Customize",
                        allAccess: checkSubDomainAccess(
                          "SETTINGS",
                          "CUSTOMIZE",
                          userById?.rolePermission
                        ),
                      },
                      {
                        sectionName: "Purchase History",
                        allAccess: checkSubDomainAccess(
                          "SETTINGS",
                          "CUSTOMIZE",
                          userById?.rolePermission
                        ),
                      },
                      // {
                      //   sectionName: "Email Templates",
                      //   allAccess: getSubDomainAccessStatus(
                      //     "SETTINGS",
                      //     "COURSES",
                      //    userById?.rolePermission
                      //   ),
                      // },
                    ]
                      .filter((item) => item !== null)
                      .map((item, index) => (
                        <GeneralSetup
                          key={index}
                          handleStatus={handleStatus}
                          index={index}
                          isActive={isActive}
                          item={item?.sectionName}
                          itemAllAccess={item?.allAccess}
                        />
                      ))}
                  </List>
                </Box>
              </Box>
            </Grid>
            <Grid
              className={styles.gridSettingsRight}
              item
              md={9}
              xs={6}
              sm={6}
              lg={9.8}
              xl={10}
              style={{
                paddingLeft: "0px",
                paddingRight: "15px",
                padding: !userFromLocalStorage.isProfileCompleted ? "" : "0px ",
              }}
              sx={{
                maxHeight: {
                  xs: "auto",
                  sm: "auto",
                  lg: "calc(100vh - 94px)",
                  md: "calc(100vh - 94px)",
                },
                minHeight: {
                  xs: "auto",
                  sm: "auto",
                  lg: "calc(100vh - 94px)",
                  md: "calc(100vh - 94px)",
                },
              }}
            >
              <ManageSettingsRouter />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
